import React from 'react';
import { Box, Link, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { formatCurrency, formatDate } from '../../../../utils/formatters';
import type { Info360ActividadItem, Info360Documento, Info360Indicadores } from '../types';
import { resolverAccionDocumento } from '../documentoAcciones';
import Info360DocumentoList from './Info360DocumentoList';

interface Props {
  data: Info360Indicadores;
  onAbrirDocumento?: (documento: Info360Documento) => void;
  onAbrirActividad?: (actividad: Info360ActividadItem) => void;
}

const Info360TabActividad: React.FC<Props> = ({ data, onAbrirDocumento, onAbrirActividad }) => (
  <Stack spacing={2}>
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1.5 }}>
        Actividad reciente
      </Typography>
      {data.actividadReciente.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Sin actividad reciente.
        </Typography>
      ) : (
        <Stack spacing={1.25}>
          {data.actividadReciente.map((item, index) => {
            const accion = onAbrirActividad ? resolverAccionDocumento(item) : null;
            return (
              <Stack
                key={`${item.tipo}-${item.descripcion}-${item.fecha}-${index}`}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="space-between"
                spacing={0.5}
              >
                <Box minWidth={0}>
                  {accion ? (
                    <Tooltip title={accion.label}>
                      <Link
                        component="button"
                        type="button"
                        underline="hover"
                        onClick={() => onAbrirActividad?.(item)}
                        aria-label={`${accion.label}: ${item.descripcion}`}
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 0.5,
                          font: 'inherit',
                          fontWeight: 600,
                          textAlign: 'left',
                        }}
                      >
                        {item.descripcion}
                        <OpenInNew sx={{ fontSize: 14 }} aria-hidden />
                      </Link>
                    </Tooltip>
                  ) : (
                    <Typography variant="body2" fontWeight={600}>{item.descripcion}</Typography>
                  )}
                  <Typography variant="caption" color="text.secondary" display="block">
                    {item.tipo} · {formatDate(item.fecha)}
                  </Typography>
                </Box>
                {item.importe != null ? (
                  <Typography variant="body2" fontWeight={600}>
                    {formatCurrency(item.importe)}
                  </Typography>
                ) : null}
              </Stack>
            );
          })}
        </Stack>
      )}
    </Paper>

    <Info360DocumentoList
      titulo="Pedidos pendientes"
      documentos={data.pedidosPendientes}
      emptyText="No hay pedidos pendientes."
      onAbrirDocumento={onAbrirDocumento}
    />
    <Info360DocumentoList
      titulo="Devoluciones recientes"
      documentos={data.devolucionesRecientes}
      emptyText="No hay devoluciones recientes."
      onAbrirDocumento={onAbrirDocumento}
    />
  </Stack>
);

export default Info360TabActividad;
